import { clsx } from "clsx";

export default function Logo({
  className,
  inverse = false,
}: {
  className?: string;
  inverse: boolean;
}): React.ReactElement {
  return (
    <svg
      className={clsx(
        "transition",
        inverse ? "text-black" : "text-white",
        className,
      )}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 538.583 89.386"
    >
      <polygon
        points="234.319 61.402 241.484 48.992 212.967 0 190.12 87.961 202.968 87.961 217.411 32.353 234.319 61.402"
        fill="#fa0032"
      />
      <polygon
        points="241.484 48.992 248.692 61.376 265.453 32.345 280.162 87.961 293.025 87.961 269.764 .008 241.484 48.992"
        fill="#14c8dc"
      />
      <path
        d="M533.592,20.431c2.76,0,4.991,2.232,4.991,4.991s-2.231,4.991-4.991,4.991-4.991-2.232-4.991-4.991,2.232-4.991,4.991-4.991ZM533.592,29.398c2.191,0,3.976-1.785,3.976-3.976s-1.785-3.976-3.976-3.976-3.976,1.785-3.976,3.976,1.785,3.976,3.976,3.976ZM531.645,22.663h2.617c.953,0,1.744.791,1.744,1.744,0,.731-.466,1.36-1.116,1.623l.934,2.15h-1.075l-.874-2.028h-1.216v2.028h-1.015v-5.517h.001ZM532.66,25.138h1.603c.404,0,.729-.325.729-.731s-.325-.729-.729-.729h-1.603v1.46ZM330.65,89.386c-19.163,0-34.752-15.592-34.752-34.756s15.589-34.752,34.752-34.752,34.759,15.59,34.759,34.752-15.592,34.756-34.759,34.756h0ZM330.65,32.229c-12.352,0-22.401,10.049-22.401,22.401s10.05,22.405,22.401,22.405,22.409-10.051,22.409-22.405-10.052-22.401-22.409-22.401ZM432.277,87.961V21.303h-12.35v44.534l-32.663-44.534h-11.501v66.659h12.352v-44.536l32.663,44.536h11.499ZM478.13,87.961v-54.308h23.153v-12.351h-58.651v12.351h23.148v54.308h12.35,0ZM523.991,87.961V21.303h-12.352v66.659h12.352ZM35.497,87.961v-54.308h23.154v-12.351H0v12.351h23.148v54.308h12.35,0ZM107.854,87.961l-13.716-22.701h-12.795v22.701h-12.35V21.303h31.286c12.143,0,22.022,9.879,22.022,22.022,0,9.413-5.892,17.618-14.584,20.692l14.49,23.944h-14.354,0ZM100.28,52.906c5.424,0,9.673-4.208,9.673-9.581,0-5.334-4.339-9.672-9.673-9.672h-18.936v19.253h18.936ZM181.502,87.961v-12.35h-36.508v-14.806h33.833v-12.35h-33.833v-14.802h36.508v-12.351h-48.857v66.659h48.857ZM218.985,87.961h14.373l8.216-14.097,8.205,14.097h14.389l-22.683-38.969-22.498,38.969h-.002Z"
        fill="currentColor"
      />
    </svg>
  );
}
